/* eslint-disable react/jsx-key */
import React, { useState, useContext } from 'react'
import { Box, Flex, FormField, Label, Select, Input } from 'pcln-design-system'
import { Calendar, Clock, Cruises, Pin, Search, User } from 'pcln-icons'
import styled from 'styled-components'
import BootstrapDataContext from '../../../context/BootstrapDataContext'
import FindYourDealButton from '../../FindYourDealButton'
import { CRUISE_PRODUCT_TYPE } from '../../../constants/products'
import {
  UNDER_FIFTY_FIVE_SELECT_UNCHOSEN_LABEL,
  UNDER_FIFTY_FIVE_SELECT_NO_LABEL,
  UNDER_FIFTY_FIVE_SELECT_YES_LABEL,
  locationOptions,
  cruiseLineOptions,
  durationOptions
} from '../constants'
import { createDateOptions, currentMonth, handleSubmit } from './utils'

const StyledInput = styled(Input)`
  background-color: white;
`

const StyledSelect = styled(Select)`
  background-color: white;
  cursor: pointer;
`

export const createOption = (
  option: {
    label: string
    value: string
    disabled?: boolean
    selected?: boolean
  },
  i: number
) => (
  <option key={`${option.label}${i}`} {...option}>
    {option.label}
  </option>
)

const locations = locationOptions.map(createOption)
const cruiseLines = cruiseLineOptions.map(createOption)
const dateOptions = createDateOptions(new Date()).map(createOption)
const durations = durationOptions.map(createOption)

const CruisesSearchForm = () => {
  const [location, setLocation] = useState('')
  const [cruiseLine, setCruiseLine] = useState('')
  const [zip, setZIP] = useState('')
  const [startDate, setStartDate] = useState(currentMonth)
  const [duration, setDuration] = useState('')
  const [under55, setUnder55] = useState('')
  const { referral = {} } = useContext(BootstrapDataContext)

  return (
    <Box>
      <Box>
        <form
          onSubmit={handleSubmit(
            {
              location,
              cruiseLine,
              zip,
              startDate,
              duration,
              under55
            },
            referral
          )}
          id="cruise-form"
          aria-label="cruise-search-form"
        >
          <Flex flexWrap="wrap" mx={-2} mb={3} width={1}>
            <Box width={[1, 1 / 2, null, null, 2 / 5]} px={2} mb={3}>
              <FormField>
                <Label autoHide={location === ''} htmlFor="location">
                  Where are you going?
                </Label>
                <Search color="primary" />
                <StyledSelect
                  id="location"
                  name="location"
                  value={location}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setLocation(e.target.value)
                  }}
                >
                  {locations}
                </StyledSelect>
              </FormField>
            </Box>
            <Box width={[1, 1 / 2, null, null, 2 / 5]} px={2} mb={3}>
              <FormField>
                <Label autoHide={cruiseLine === ''} htmlFor="cruiseLine">
                  Which cruise line?
                </Label>
                <Cruises color="primary" />
                <StyledSelect
                  id="cruiseLine"
                  name="cruiseLine"
                  value={cruiseLine}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setCruiseLine(e.target.value)
                  }}
                >
                  {cruiseLines}
                </StyledSelect>
              </FormField>
            </Box>
            <Box width={[1, 1 / 2, null, null, 1 / 5]} px={2} mb={3}>
              <FormField>
                <Label autoHide={zip === ''} htmlForm="zip">
                  ZIP code
                </Label>
                <Pin color="primary" />
                <StyledInput
                  id="zip"
                  name="zip"
                  value={zip}
                  placeholder="ZIP code"
                  minLength="5"
                  maxLength="5"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setZIP(e.target.value)
                  }}
                />
              </FormField>
            </Box>
            <Box width={[1, 1 / 2, null, null, 1 / 4]} px={2} mb={3}>
              <FormField>
                <Label autoHide htmlFor="startDate">
                  Departing
                </Label>
                <Calendar color="primary" />
                <StyledSelect
                  id="startDate"
                  name="startDate"
                  value={startDate}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setStartDate(e.target.value)
                  }}
                >
                  {dateOptions}
                </StyledSelect>
              </FormField>
            </Box>
            <Box width={[1, 1 / 2, null, null, 1 / 4]} px={2} mb={3}>
              <FormField>
                <Label autoHide={duration === ''} htmlFor="duration">
                  Cruise length
                </Label>
                <Clock color="primary" />
                <StyledSelect
                  id="duration"
                  name="duration"
                  value={duration}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setDuration(e.target.value)
                  }}
                >
                  {durations}
                </StyledSelect>
              </FormField>
            </Box>
            <Box width={[1, 1 / 2, null, null, 1 / 4]} px={2} mb={3}>
              <FormField>
                <Label autoHide={under55 === ''} htmlFor="underFiftyFive">
                  Under 55
                </Label>
                <User color="primary" />
                <StyledSelect
                  id="underFiftyFive"
                  name="underFiftyFive"
                  value={under55}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setUnder55(e.target.value)
                  }}
                >
                  <option disabled value="" label="Under 55" defaultValue="">
                    {UNDER_FIFTY_FIVE_SELECT_UNCHOSEN_LABEL}
                  </option>
                  <option value="false" label="No">
                    {UNDER_FIFTY_FIVE_SELECT_NO_LABEL}
                  </option>
                  <option value="true" label="Yes">
                    {UNDER_FIFTY_FIVE_SELECT_YES_LABEL}
                  </option>
                </StyledSelect>
              </FormField>
            </Box>
            <Box width={[1, null, null, null, 1 / 4]} px={2} ml="auto">
              <FindYourDealButton currentProduct={CRUISE_PRODUCT_TYPE} />
            </Box>
          </Flex>
        </form>
      </Box>
    </Box>
  )
}

export default CruisesSearchForm
